// src/pages/ServiceFinder/ServiceSearch.js
import {React, useState, useEffect, Fragment, memo, useRef} from "react";
import Container from "@mui/material/Container";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { api_Routes } from "../../../api_Routes";
import LinearProgress from "@mui/material/LinearProgress";
import { Helper, isLogin } from "../../../tools/Helper";
import {Pagination, Slider} from "@mui/material";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Pin from "./PinsDown&PinsUp/Pin";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  Button,
  useMediaQuery,
  useTheme
} from "@mui/material";
import DataTableColumn from "./data-table-column";
import Filters from "../filters";
import { useCurrency } from "../../../Context/CurrencyContext";
import Typography from "@mui/material/Typography";
import PanelCard from "../../PanelCard";

const MemoizedFilters = memo(Filters);

const ServiceSearch = ({
                         countries,
                         categories,
                         pinup,
                         pinDown,
                         mostsearched,
                         setFirstSearch,
                       }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [triggerSearch, setTriggerSearch] = useState("");
  const [selectedCountry, setSelectedCountry] = useState([]);
  const [selectedCategories, setSelectedCategories] = useState("");
  const [dataTable, setDataTable] = useState([]);
  const [sortOrder, setSortOrder] = useState("asc");
  const { rate } = useCurrency();
  const symbols = Object.keys(rate);
  const symbol = symbols[0];
  const exchangeRate = rate[symbol];
  const [Panels, setPanels] = useState([]);
  const [currentSignal, setCurrentSignal] = useState(null);
  const [limit, setLimit] = useState(50);
  const [limitForPanel, setLimitForPanel] = useState(25);
  const [page, setPage] = useState(0);
  const [pageForPanel, setPageForPanel] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [totalItems, setTotalItems] = useState(0);
  const [totalItemsForPanel, setTotalItemsForPanel] = useState(0);
  const [onSee, setOnSee] = useState(true);
  const [sortedOptions, setSortedOptions] = useState([...countries]);
  const [selectedSubcategory, setSelectedSubcategory] = useState([]);
  const [selectedFilters, setSelectedFilters] = useState([]);
  const [showTable, setShowTable] = useState(false);
  const [selectedFeature, setSelectedFeature] = useState([]);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  // Add ref to track the latest request
  const abortControllerRef = useRef(null);

  const columns = [
    { id: "id", label: "ID", minWidth: 50 },
    { id: "name", label: "Service", minWidth: 100 },
    { id: "panelUrl", label: "Panel", minWidth: 100 },
    { id: "rate_per_1000", label: "Rate", minWidth: 50 },
    { id: "order_range", label: "Min & Max", minWidth: 100 },
    { id: "category", label: "Category", minWidth: 200 },
    { id: "description", label: "Description", minWidth: 200 },
  ];

  const marks = [
    { value: 0, label: "0" },
    { value: 20, label: "1$" },
    { value: 40, label: "5$" },
    { value: 60, label: "10$" },
    { value: 80, label: "100$" },
    { value: 100, label: "1000$" },
  ];

  const valueMap = {
    0: 0,
    20: 1,
    40: 5,
    60: 10,
    80: 100,
    100: 1000,
  };

  useEffect(() => {
    setSortedOptions(
        [...countries].sort(
            (a, b) => selectedCountry.includes(b.id) - selectedCountry.includes(a.id)
        )
    );
  }, [countries, selectedCountry]);

  const handleCountryChange = (newValues) => {
    if (newValues.some((Cou) => Cou.id === "All")) setSelectedCountry([]);
    else setSelectedCountry(newValues.map((Cou) => Cou.id));
  };

  const [minPrice, setMinPrice] = useState();
  const [maxPrice, setMaxPrice] = useState();
  const [value, setValue] = useState([1, 100]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
    setMinPrice(valueMap[newValue[0]]);
    setMaxPrice(valueMap[newValue[1]]);
  };

  const baseApi = api_Routes.Search.servers;

  const toggleFilter = (filter) => {
    setSelectedFilters((prevFilters) => {
      const newFilters = [...prevFilters];
      if (filter === "Provider") {
        if (newFilters.includes("Reseller")) {
          newFilters.splice(newFilters.indexOf("Reseller"), 1);
        }
      } else if (filter === "Reseller") {
        if (newFilters.includes("Provider")) {
          newFilters.splice(newFilters.indexOf("Provider"), 1);
        }
      }
      if (newFilters.includes(filter)) {
        newFilters.splice(newFilters.indexOf(filter), 1);
      } else {
        newFilters.push(filter);
      }
      return newFilters;
    });
  };

  const toggleFeatureFilter = (Feature) => {
    setSelectedFeature((PrevFeature) => {
      const newFeature = [...PrevFeature];
      if (newFeature.includes(Feature)) {
        newFeature.splice(newFeature.indexOf(Feature), 1);
      } else {
        newFeature.push(Feature);
      }
      return newFeature;
    });
  };

  const handleSortByPrice = (order) => {
    setSortOrder(order);
  };

  // Reset page when filters change (except page/limit)
  useEffect(() => {
    if (showTable) {
      setPage(0);
      setPageForPanel(0);
    }
  }, [searchTerm, selectedCountry, selectedCategories, selectedSubcategory, selectedFilters, selectedFeature, minPrice, maxPrice, sortOrder]);

  useEffect(() => {
    // Cancel previous request
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
    }

    const controller = new AbortController();
    abortControllerRef.current = controller;

    if (
        searchTerm.trim() !== "" ||
        selectedCountry?.length > 0 ||
        selectedCategories ||
        selectedSubcategory?.length > 0 ||
        selectedFilters?.length > 0 ||
        selectedFeature?.length > 0 ||
        minPrice ||
        maxPrice ||
        (sortOrder &&
            (searchTerm.trim() !== "" ||
                selectedCountry?.length > 0 ||
                selectedCategories ||
                selectedSubcategory?.length > 0 ||
                selectedFilters?.length > 0 ||
                selectedFeature?.length > 0 ||
                minPrice ||
                maxPrice))
    ) {
      get_service(controller.signal);
    }

    return () => {
      controller.abort();
    };
  }, [triggerSearch, page, limit]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const getSubCategories = () => {
    const category = categories.find((cat) => cat.id === selectedCategories);
    return category ? category.subCategories : [];
  };

  const handleLimitChange = (event) => {
    setLimit(parseInt(event.target.value, 10));
    setPage(0);
  };

  const get_service = async (signal) => {
    setIsLoading(true);
    setFirstSearch(false);

    let url = `${baseApi}?page=${page + 1}&limit=${limit}`;
    if (searchTerm) url += `&keyword=${searchTerm}`;
    if (selectedCountry?.length > 0) {
      selectedCountry.forEach((id) => {
        url += `&country_id[]=${id}`;
      });
    }
    if (selectedCategories) url += `&category_id=${selectedCategories}`;
    if (selectedSubcategory?.length > 0) {
      selectedSubcategory.forEach((id) => {
        url += `&sub_category_id[]=${id}`;
      });
    }
    if (selectedFilters?.length > 0) {
      selectedFilters.forEach((filter) => {
        url += `&${filter}=1`;
      });
    }
    if (selectedFeature?.length > 0) {
      selectedFeature.forEach((Feature) => {
        url += `&${Feature}=1`;
      });
    }
    if (minPrice && maxPrice) {
      url += `&minPrice=${minPrice}&maxPrice=${maxPrice}`;
    } else if (minPrice && !maxPrice) {
      url += `&minPrice=${minPrice}&maxPrice=${1000}`;
    } else if (!minPrice && maxPrice) {
      url += `&minPrice=${0}&maxPrice=${maxPrice}`;
    }
    if (sortOrder) url += `&sort_by_price=${sortOrder}`;

    try {
      const { response } = await Helper.Get({
        url: url,
        hasToken: true,
        signal: signal,
      });

      // Check if the request was aborted
      if (signal.aborted) return;

      if (response) {
        const { data, pagination } = response;
        setTotalItems(pagination.services.total);
        setTotalItemsForPanel(pagination.panels.total);
        setDataTable(
            data.services.map((panel) => ({
              id: panel.id,
              name: panel.name,
              panelUrl: panel.panelUrl,
              rate_per_1000: panel.rate_per_1000.includes("$")
                  ? parseFloat(panel.rate_per_1000.replace("$", ""))
                  : panel.rate_per_1000,
              order_range: `${panel.min_order} / ${panel.max_order}`,
              description: panel.description,
              category: panel.category,
              search_first: panel.search_first,
              panel_uuid: panel.panel_uuid,
              action: "View",
            }))
        );
        setPanels(data.panels || []);
      } else {
        setFirstSearch(true);
        // Clear data when no response
        setDataTable([]);
        setPanels([]);
        setTotalItems(0);
        setTotalItemsForPanel(0);
      }
    } catch (error) {
      if (error.name === 'AbortError') {
        // Request was cancelled, do nothing
        return;
      }
      // Handle other errors
      console.error('Error fetching services:', error);
      setDataTable([]);
      setPanels([]);
      setTotalItems(0);
      setTotalItemsForPanel(0);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSearchClick = () => {
    if (
        searchTerm.trim() !== "" ||
        selectedCountry?.length > 0 ||
        selectedCategories ||
        selectedSubcategory?.length > 0 ||
        selectedFilters?.length > 0 ||
        selectedFeature?.length > 0 ||
        minPrice ||
        maxPrice ||
        (sortOrder &&
            (searchTerm.trim() !== "" ||
                selectedCountry?.length > 0 ||
                selectedCategories ||
                selectedSubcategory?.length > 0 ||
                selectedFilters?.length > 0 ||
                selectedFeature?.length > 0 ||
                minPrice ||
                maxPrice))
    ) {
      setShowTable(true);

      // Clear previous data immediately
      setDataTable([]);
      setPanels([]);

      // Reset to first page
      setPage(0);
      setPageForPanel(0);

      setTimeout(() => {
        if (searchTerm.trim() !== "") {
          if (searchTerm !== triggerSearch) {
            setTriggerSearch(searchTerm);
          } else {
            // If search term hasn't changed but other filters have, force refresh
            const controller = new AbortController();
            abortControllerRef.current = controller;
            get_service(controller.signal);
          }
        } else {
          const controller = new AbortController();
          abortControllerRef.current = controller;
          get_service(controller.signal);
        }
      }, 0);

      if (onSee) {
        Helper.Post({
          url: api_Routes.Pin.OnSee,
          hasToken: true,
        });
        setOnSee(false);
      }
    }
  };

  const handleKeyDown = (event) => {
    if (
        event.key === "Enter" &&
        !isLoading &&
        (searchTerm.trim() !== "" ||
            selectedCountry?.length > 0 ||
            selectedCategories ||
            selectedSubcategory?.length > 0 ||
            selectedFilters?.length > 0 ||
            selectedFeature?.length > 0 ||
            minPrice ||
            maxPrice)
    ) {
      handleSearchClick();
    }
  };

  const handlePageChange = (event, newPage) => {
    const updatedPage = newPage - 1;
    setPage(updatedPage);
  };

  return (
      <>
        <Box sx={{
          width: '80%',
          backgroundColor: 'white',
          borderRadius: '0 0 16px 16px',
          boxShadow: '0px -2px 10px rgba(0, 0, 0, 0.1)',
          zIndex: 10,
          position: 'relative',
          justifySelf:'center'
        }}>
          <MemoizedFilters
              mostsearched={mostsearched}
              sortOrder={sortOrder}
              selectedFeature={selectedFeature}
              toggleFeatureFilter={toggleFeatureFilter}
              valueMap={valueMap}
              marks={marks}
              handleChange={handleChange}
              value={value}
              Slider={Slider}
              selectedFilters={selectedFilters}
              toggleFilter={toggleFilter}
              handleCountryChange={handleCountryChange}
              sortedOptions={sortedOptions}
              setSelectedSubcategory={setSelectedSubcategory}
              getSubCategories={getSubCategories}
              setSelectedCategories={setSelectedCategories}
              selectedCategories={selectedCategories}
              categories={categories}
              handleSearchClick={handleSearchClick}
              maxPrice={maxPrice}
              minPrice={minPrice}
              selectedSubcategory={selectedSubcategory}
              selectedCountry={selectedCountry}
              searchTerm={searchTerm}
              isLoading={isLoading}
              handleKeyDown={handleKeyDown}
              setSearchTerm={setSearchTerm}
              handleSortByPrice={handleSortByPrice}
          />
        </Box>

        {showTable && (
            <>
              <Pin pin={pinup} />

              {dataTable?.length > 0 || isLoading ? (
                  <Container
                      fluid={true}
                      sx={{
                        marginTop: "20px",
                        marginBottom: "30px",
                        padding: 0,
                        maxWidth: "100vw",
                        overflowX: "hidden",
                        "@media (min-width: 1200px)": {
                          maxWidth: "1600px",
                        },
                      }}
                  >
                    <Grid container>
                      <Grid item xs={12}>
                        <Card sx={{ borderRadius: "22px" }}>
                          <CardContent sx={{ background: "#D2E2EC" }}>
                            {isLoading && <LinearProgress />}
                            <TableContainer style={{ background: "#D2E2EC" }}>
                              <Table stickyHeader sx={{ background: "#D2E2EC" }}>
                                <TableHead>
                                  <TableRow>
                                    {columns.map((column, index) => (
                                        <TableCell
                                            key={column.id}
                                            style={{
                                              background: "#D2E2EC",
                                              fontSize: "20px",
                                              fontWeight: "bolder",
                                              lineHeight: "20px",
                                              color: "#474747",
                                              border: "1px solid #00000080",
                                              textAlign: "center",
                                            }}
                                        >
                                          {column.label}
                                        </TableCell>
                                    ))}
                                  </TableRow>
                                </TableHead>
                                <TableBody>
                                  {dataTable.map((row) => (
                                      <TableRow
                                          hover
                                          role="checkbox"
                                          tabIndex={-1}
                                          key={row.id}
                                          style={{
                                            backgroundColor: row.search_first
                                                ? "#93BBD5"
                                                : "#D2E2EC",
                                          }}
                                      >
                                        {columns.map((column, index) => {
                                          const value = row[column.id];
                                          if (column.id == "rate_per_1000") {
                                            return (
                                                <DataTableColumn
                                                    row={row}
                                                    column={column}
                                                    value={
                                                      `${(value * exchangeRate).toFixed(7).replace(/(\.\d*?[1-9])0+$/, '$1').replace(/\.$/, '')}${symbol}`
                                                    }
                                                    panelUuid={row.panel_uuid}
                                                />
                                            );
                                          } else if (column.id == "panelUrl" && row.search_first ){
                                            return (
                                                <DataTableColumn
                                                    row={row}
                                                    column={column}
                                                    value={value}
                                                    panelUuid={row.panel_uuid}
                                                />
                                            );
                                          } else {
                                            return (
                                                <DataTableColumn
                                                    row={row}
                                                    column={column}
                                                    value={value}
                                                    panelUuid={row.panel_uuid}
                                                />
                                            );
                                          }
                                        })}
                                      </TableRow>
                                  ))}
                                </TableBody>
                              </Table>
                            </TableContainer>
                          </CardContent>
                        </Card>
                      </Grid>
                    </Grid>
                  </Container>
              ) : (
                  !isLoading && (
                      <Container
                          fluid={true}
                          sx={{
                            marginTop: "20px",
                            marginBottom: "30px",
                            padding: 0,
                            maxWidth: "100vw",
                            overflowX: "hidden",
                            "@media (min-width: 1200px)": {
                              maxWidth: "1600px",
                            },
                          }}
                      >
                        <Grid container>
                          <Grid item xs={12}>
                            <Card sx={{ borderRadius: "22px" }}>
                              <CardContent sx={{ background: "#D2E2EC" }}>
                                <TableContainer style={{ background: "#D2E2EC" }}>
                                  <Table stickyHeader sx={{ background: "#D2E2EC" }}>
                                    <TableHead>
                                      <TableRow>
                                        <TableCell
                                            style={{
                                              background: "#D2E2EC",
                                              fontSize: "20px",
                                              fontWeight: "bolder",
                                              lineHeight: "20px",
                                              color: "#474747",
                                              border: "1px solid #00000080",
                                              textAlign: "center",
                                            }}
                                        >
                                          There are no services with this search data
                                        </TableCell>
                                      </TableRow>
                                    </TableHead>
                                  </Table>
                                </TableContainer>
                              </CardContent>
                            </Card>
                          </Grid>
                        </Grid>
                      </Container>
                  )
              )}

              {dataTable?.length > 0 && (
                  <Box
                      sx={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "center",
                        background: "#D2E2EC",
                        flexWrap: "wrap",
                      }}
                  >
                    <TablePagination
                        rowsPerPageOptions={[ 25, 50,100]}
                        count={totalItems}
                        rowsPerPage={limit}
                        page={page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleLimitChange}
                    />
                  </Box>
              )}

              <Box
                  sx={{
                    background: "white",
                    marginInline: "40px",
                    padding: {
                      xs: "20px 40px",
                      sm: "20px 30px",
                      lg: " 20px 80px ",
                    },
                    marginBottom: "40px",
                    borderRadius: "20px",
                  }}
              >
                {Panels.length > 0 ? (
                    <>
                      <Grid container spacing={3}>
                        {Panels.map((panel, index) => (
                            <Grid
                                item
                                xs={12}
                                sm={6}
                                md={4}
                                lg={3}
                                key={index}
                                sx={{ height: "416px", width: "308px" }}
                            >
                              <PanelCard data={panel} isprovider={true} />
                            </Grid>
                        ))}
                      </Grid>
                      <Box
                          sx={{
                            my: 2,
                            display: "flex",
                            flexDirection: { xs: "column", sm: "row" },
                            justifyContent: { sm: "space-evenly", xs: "center" },
                            alignItems: "center",
                            gap: { xs: 2, sm: 0 },
                            textAlign: { xs: "center", sm: "left" },
                          }}
                      >
                        <Box
                            sx={{
                              display: "flex",
                              flexDirection: { xs: "column", sm: "row" },
                              gap: "8px",
                              alignItems: "center",
                            }}
                        >
                          <Typography
                              variant="body1"
                              sx={{
                                color: "#004571",
                                fontSize: { xs: "13px", sm: "15px" },
                                lineHeight: "18px",
                                fontWeight: "400",
                              }}
                          >
                            {totalItemsForPanel} results{" "}
                          </Typography>
                          <Typography
                              variant="body1"
                              sx={{
                                color: "#004571",
                                fontSize: { xs: "13px", sm: "15px" },
                                lineHeight: "18px",
                                fontWeight: "400",
                              }}
                          >
                            |
                          </Typography>
                          <Typography
                              variant="body1"
                              sx={{
                                color: "#004571",
                                fontSize: { xs: "13px", sm: "15px" },
                                lineHeight: "18px",
                                fontWeight: "400",
                              }}
                          >
                            Showing {pageForPanel + 1} of {Math.ceil(totalItemsForPanel / limitForPanel)} pages
                          </Typography>
                        </Box>

                        <Pagination
                            count={Math.ceil(totalItemsForPanel / limitForPanel)}
                            page={pageForPanel + 1}
                            onChange={handlePageChange}
                            variant="outlined"
                            shape="rounded"
                            showFirstButton
                            showLastButton
                            siblingCount={1}
                            boundaryCount={1}
                            sx={{
                              mt: { xs: 2, sm: 0 },
                              "& .MuiPagination-ul": {
                                justifyContent: { xs: "center", sm: "flex-start" },
                                gap: "10px"
                              },
                            }}
                        />
                      </Box>
                    </>
                ) : (
                    !isLoading && (
                        <Box sx={{ textAlign: "center", padding: "20px" }}>
                          <Typography variant="h6">No panels found. Please add your own panel</Typography>
                          <Button
                              sx={{
                                textAlign: "center",
                                borderRadius: "10px",
                                padding: "5px 10px",
                                background: "#3F78E0",
                                color: "white",
                                boxShadow: "0px 5px 5px #00000040, inset 4px 7px 5px #FFFFFF30",
                                "&:hover": {
                                  background: "#2E5DBA",
                                },
                                mt: 1,
                              }}
                              onClick={() => {
                                window.open(`${window.location.origin}/AddPanel`, '_blank', 'noopener,noreferrer');
                              }}
                          >
                            Add Panel
                          </Button>
                        </Box>
                    )
                )}
              </Box>

              <Pin pin={pinDown} />
            </>
        )}
      </>
  );
};

export default ServiceSearch;